<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <newsPopup v-if="showNews"/>
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import auth        from '@/http/requests/auth'
import newsPopup   from '@/components/news-popup/NewsPopup'


export default {
  components: {
    newsPopup
  },
  data () {
    return {
      vueAppClasses: [],
      defaultMetaTitle: 'Broking Suite',
      showNews: false,
    }
  },
  watch: {
    '$route': {
      handler(val) {
        const metaTitle = val.name === 'dashboard'
          ? null
          : val.meta.metaTitle;
        
        this.setMetaTitle(metaTitle)
      },
      deep: true,
      immidiate: true,
    },
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    }
  },
  methods: {
    async setMetaTitle(pageName = null) {
      let metaTitle = this.defaultMetaTitle;

      if (pageName) {
        metaTitle = this.$t(pageName);
      }

      if (this.user) {
        metaTitle += ` - ${this.user.email}`;
      }

      document.getElementById("metaTitle").innerHTML = metaTitle;
    },

    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  mounted () {
    this.user = this.$store.getters['auth/user'];
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    this.setMetaTitle();

    if (process.env.VUE_APP_ENVIRONMENT === 'production') {
      window.dataLayer.push({
          'event': 'userData',
          'user_id': this.user.sub,
        });
    }

  },
  async created () {
    // auth
    auth.init()
    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)
    // Auth0

    await this.$auth.setup();

    const checkAuth = async () => {
      try {
        const isAuthenticated = await this.$store.getters['auth/isAuthenticated'];

        if (isAuthenticated) {
          this.showNews = true;
        } else {
          this.showNews = false;
          setTimeout(checkAuth, 2000);
        }
      } catch (error) {
        setTimeout(checkAuth, 2000);
      }
    };

    checkAuth();
  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

</script>
